import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
Vue.use(VueRouter)

import Head from '@/components/Head.vue'
import Foot from '@/components/Foot.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: () => import('@/views/Home.vue'),
        }
    },
    {
        path: '/about',
        name: 'About',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/About.vue"], resolve))
        }
    },
    {
        path: '/product',
        name: 'Product',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/Product.vue"], resolve))
        }
    },
    {
        path: '/successful',
        name: 'Successful',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/Successful.vue"], resolve))
        }
    },
    {
        path: '/news/:label',
        name: 'News',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/News.vue"], resolve))
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/Contact.vue"], resolve))
        }
    },
    {
        path: '/newsDetail/:id',
        name: 'NewsDetail',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/NewsDetail.vue"], resolve))
        }
    },
    {
        path: '/cxxt01',
        name: 'cxxt01',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/CXXT01.vue"], resolve))
        }
    },
    {
        path: '/cxxt02',
        name: 'cxxt02',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/CXXT02.vue"], resolve))
        }
    },
    {
        path: '/jkzx',
        name: 'jkzx',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/JKZX.vue"], resolve))
        }
    },
    {
        path: '/czpt',
        name: 'czpt',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/CZPT.vue"], resolve))
        }
    },
    {
        path: '/xybb',
        name: 'xybb',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/XYBB.vue"], resolve))
        }
    },
    {
        path: '/lljk',
        name: 'lljk',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/LLJK.vue"], resolve))
        }
    },
    {
        path: '/cxc',
        name: 'cxc',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/CXC.vue"], resolve))
        }
    },
    {
        path: '/rhj',
        name: 'rhj',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/RHJ.vue"], resolve))
        }
    },
    {
        path: '/xxw',
        name: 'xxw',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/XXW.vue"], resolve))
        }
    },
    {
        path: '/bxcxxt03s',
        name: 'bxcxxt03s',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/BXCXXT03S.vue"], resolve))
        }
    },
    {
        path: '/bxcxxt03z',
        name: 'bxcxxt03z',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/BXCXXT03Z.vue"], resolve))
        }
    },
    {
        path: '/xxzzfwxt',
        name: 'xxzzfwxt',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/XXZZFWXT.vue"], resolve))
        }
    },
    {
        path: '/cxyzhb',
        name: 'cxyzhb',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/CXYZHB.vue"], resolve))
        }
    },
    {
        path: '/cxybzb',
        name: 'cxybzb',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/CXYBZB.vue"], resolve))
        }
    },
    {
        path: '/thirdCxxt800',
        name: 'thirdCxxt800',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/ThirdCxxt800.vue"], resolve))
        }
    },
    {
        path: '/thirdCxxt240',
        name: 'thirdCxxt240',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/ThirdCxxt240.vue"], resolve))
        }
    },    
    {
        path: '/thirdCxxt240M',
        name: 'thirdCxxt240M',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/ThirdCxxt240M.vue"], resolve))
        }
    },
    {
        path: '/thirdZtxcjxt',
        name: 'thirdZtxcjxt',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/ThirdZtxcjxt.vue"], resolve))
        }
    },
    {
        path: '/thirdCxxt300',
        name: 'thirdCxxt300',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/ThirdCxxt300.vue"], resolve))
        }
    },
    {
        path: '/thirdBbzyjqr',
        name: 'thirdBbzyjqr',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/ThirdBbzyjqr.vue"], resolve))
        }
    },
    {
        path: '/thirdNggl',
        name: 'thirdNggl',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/ThirdNggl.vue"], resolve))
        }
    },
    {
        path: '/thirdBbfj',
        name: 'thirdBbfj',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/ThirdBbfj.vue"], resolve))
        }
    },
    {
        path: '/thirdDgncxzjhszz',
        name: 'thirdDgncxzjhszz',
        meta: {
            keepAlive: false
        },
        components: {
            header: Head,
            footer: Foot,
            default: resolve => (require(["@/views/products/ThirdDgncxzjhszz.vue"], resolve))
        }
    },
    {
        path: '*',
        name: '404',
        component: resolve => (require(["@/views/404.vue"], resolve))
    },
]




const router = new VueRouter({
    mode: 'history',
    // base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) => {
    store.commit('clearToken')
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    next()
})
export default router
